(function () {
  'use strict';

  if (window.__pbcTrackingInitialized) return;
  window.__pbcTrackingInitialized = true;
  window.dataLayer = window.dataLayer || [];

  var CURRENCY = 'MYR';
  var FIRST_TOUCH_KEY = 'pbc_attribution_first_v1';
  var SESSION_TOUCH_KEY = 'pbc_attribution_session_v1';
  var PENDING_ADD_KEY = 'pbc_pending_add_v1';
  var PENDING_CART_KEY = 'pbc_pending_cart_v1';
  var context = readJson('PbcTrackingContext') || {};
  var recentEvents = new Map();
  var currentCart = normalizeCart(context.cart || {});
  var attribution = captureAttribution();

  function readJson(id) {
    try {
      var node = document.getElementById(id);
      return node ? JSON.parse(node.textContent) : null;
    } catch (error) {
      return null;
    }
  }

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) {}
  }

  function storageRemove(storage, key) {
    try { storage.removeItem(key); } catch (error) {}
  }

  function safeText(value, maxLength) {
    if (value === null || value === undefined) return '';
    return String(value).trim().slice(0, maxLength || 200);
  }

  function safeSearchTerm(value) {
    var term = safeText(value, 120);
    if (!term || /@/.test(term) || /\b\+?\d[\d\s().-]{7,}\b/.test(term)) return '';
    return term;
  }

  function numeric(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function cleanUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function cleanPath(value) {
    try { return new URL(value, window.location.origin).pathname; } catch (error) { return ''; }
  }

  function sanitizeObject(value) {
    if (Array.isArray(value)) return value.map(sanitizeObject);
    if (!value || typeof value !== 'object') return value;
    var blocked = /^(email|phone|customer_name|first_name|last_name|address|address1|address2|postal|postcode|zip|card_number|payment_details)$/i;
    return Object.keys(value).reduce(function (result, key) {
      if (!blocked.test(key)) result[key] = sanitizeObject(value[key]);
      return result;
    }, {});
  }

  function parseStoredJson(storage, key) {
    try { return JSON.parse(storageGet(storage, key) || 'null'); } catch (error) { return null; }
  }

  function captureAttribution() {
    var query = new URLSearchParams(window.location.search);
    var allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'];
    var touch = {};
    allowed.forEach(function (key) {
      var value = safeSearchTerm(query.get(key));
      if (value) touch[key] = value;
    });
    touch.landing_page = cleanUrl(window.location.href);
    touch.landing_page_path = window.location.pathname;
    touch.initial_referrer = cleanUrl(document.referrer);
    touch.session_source = touch.utm_source || (function () {
      try { return document.referrer ? new URL(document.referrer).hostname : 'direct'; } catch (error) { return 'direct'; }
    })();
    touch.captured_at = new Date().toISOString();

    var first = parseStoredJson(window.localStorage, FIRST_TOUCH_KEY);
    if (!first) {
      first = touch;
      storageSet(window.localStorage, FIRST_TOUCH_KEY, JSON.stringify(first));
    }
    var session = parseStoredJson(window.sessionStorage, SESSION_TOUCH_KEY);
    if (!session || allowed.some(function (key) { return Boolean(touch[key]); })) {
      session = touch;
      storageSet(window.sessionStorage, SESSION_TOUCH_KEY, JSON.stringify(session));
    }
    return { first_touch: first, session_touch: session };
  }

  function basePayload() {
    return {
      page_type: safeText(context.page_type || document.body.dataset.pageType, 60),
      page_path: window.location.pathname,
      page_title: safeText(document.title, 200),
      attribution: attribution
    };
  }

  function shouldSuppress(key, windowMs) {
    if (!key) return false;
    var now = Date.now();
    var previous = recentEvents.get(key) || 0;
    recentEvents.set(key, now);
    return now - previous < (windowMs || 800);
  }

  function track(eventName, payload, options) {
    try {
      options = options || {};
      var dedupeKey = options.dedupeKey || '';
      if (shouldSuppress(dedupeKey, options.dedupeWindow)) return false;
      var eventPayload = Object.assign({ event: eventName }, basePayload(), sanitizeObject(payload || {}));
      if (eventPayload.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(eventPayload);
      return true;
    } catch (error) {
      return false;
    }
  }

  window.pbcTrack = function (eventName, payload, options) {
    return track(safeText(eventName, 80), payload, options);
  };

  function normalizeItem(item, overrides) {
    item = item || {};
    overrides = overrides || {};
    return {
      item_id: safeText(overrides.item_id || item.item_id || item.id, 100),
      item_name: safeText(overrides.item_name || item.item_name || item.title, 240),
      item_brand: safeText(overrides.item_brand || item.item_brand || item.vendor, 120),
      item_category: safeText(overrides.item_category || item.item_category || item.product_type, 120),
      item_category2: safeText(overrides.item_category2 || item.item_category2, 120),
      item_variant: safeText(overrides.item_variant || item.item_variant || item.variant_title, 180),
      item_list_name: safeText(overrides.item_list_name || item.item_list_name, 160),
      item_list_id: safeText(overrides.item_list_id || item.item_list_id, 120),
      index: numeric(overrides.index || item.index || 1),
      price: numeric(overrides.price !== undefined ? overrides.price : item.price),
      quantity: Math.max(1, numeric(overrides.quantity !== undefined ? overrides.quantity : item.quantity || 1))
    };
  }

  function normalizeCart(cart) {
    cart = cart || {};
    var pricesInMinorUnits = cart.total_price !== undefined;
    return {
      value: numeric(cart.value !== undefined ? cart.value : cart.total_price ? cart.total_price / 100 : 0),
      items: (cart.items || []).map(function (item, index) {
        var normalized = normalizeItem(item, {
          item_id: item.item_id || item.variant_id || item.id,
          item_name: item.item_name || item.product_title,
          item_brand: item.item_brand || item.vendor,
          item_category: item.item_category || item.product_type,
          item_category2: item.item_category2 || 'Cart',
          item_variant: item.item_variant || item.variant_title,
          price: item.price !== undefined ? (pricesInMinorUnits ? numeric(item.final_price || item.price) / 100 : numeric(item.price)) : 0,
          quantity: item.quantity,
          index: index + 1
        });
        normalized.line_key = item.line_key || item.key || '';
        normalized.product_handle = item.product_handle || item.handle || '';
        return normalized;
      })
    };
  }

  function itemFromCard(card) {
    if (!card) return null;
    var list = card.closest('[data-pbc-product-list]');
    return normalizeItem({}, {
      item_id: card.dataset.pbcItemId,
      item_name: card.dataset.pbcItemName,
      item_brand: card.dataset.pbcItemBrand,
      item_category: card.dataset.pbcItemCategory,
      item_category2: card.dataset.pbcItemCategory2,
      item_variant: card.dataset.pbcItemVariant,
      item_list_name: list ? list.dataset.pbcListName : card.dataset.pbcListName,
      item_list_id: list ? list.dataset.pbcListId : card.dataset.pbcListId,
      index: card.dataset.pbcIndex,
      price: card.dataset.pbcPrice,
      quantity: 1
    });
  }

  function cartQuantity(cart, itemId) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (String(item.item_id) === String(itemId) ? numeric(item.quantity) : 0);
    }, 0);
  }

  function trackCartDifferences(previousCart, nextCart) {
    (previousCart.items || []).forEach(function (before) {
      var afterQuantity = cartQuantity(nextCart, before.item_id);
      var removedQuantity = numeric(before.quantity) - afterQuantity;
      if (removedQuantity <= 0) return;
      var item = normalizeItem(before, { quantity: removedQuantity });
      track('remove_from_cart', {
        ecommerce: { currency: CURRENCY, value: item.price * removedQuantity, items: [item] }
      }, { dedupeKey: 'remove:' + item.item_id + ':' + before.quantity + ':' + afterQuantity + ':' + window.location.pathname, dedupeWindow: 10000 });
    });
    currentCart = nextCart;
  }

  function reconcilePendingActions() {
    var pendingAdd = parseStoredJson(window.sessionStorage, PENDING_ADD_KEY);
    if (pendingAdd) {
      storageRemove(window.sessionStorage, PENDING_ADD_KEY);
      var addedQuantity = cartQuantity(currentCart, pendingAdd.item.item_id) - numeric(pendingAdd.before_quantity);
      if (addedQuantity > 0) {
        var addedItem = normalizeItem(pendingAdd.item, { quantity: addedQuantity });
        track('add_to_cart', {
          ecommerce: { currency: CURRENCY, value: addedItem.price * addedQuantity, items: [addedItem] }
        }, { dedupeKey: 'confirmed-add:' + addedItem.item_id + ':' + pendingAdd.created_at, dedupeWindow: 300000 });
      }
    }

    var pendingCart = parseStoredJson(window.sessionStorage, PENDING_CART_KEY);
    if (pendingCart) {
      storageRemove(window.sessionStorage, PENDING_CART_KEY);
      trackCartDifferences(normalizeCart(pendingCart.cart), currentCart);
    }
  }

  function trackPageAndLists() {
    track('page_view', {
      page_location: cleanUrl(window.location.href),
      page_referrer: cleanUrl(document.referrer)
    }, { dedupeKey: 'page_view:' + window.location.pathname + window.location.search, dedupeWindow: 10000 });

    var term = safeSearchTerm(context.search_term);
    if (term) track('search', { search_term: term }, { dedupeKey: 'search:' + term, dedupeWindow: 10000 });

    if (context.product) {
      var productItem = normalizeItem(context.product);
      track('view_item', {
        product_handle: context.product.product_handle || '',
        ecommerce: { currency: CURRENCY, value: productItem.price, items: [productItem] }
      }, { dedupeKey: 'view_item:' + productItem.item_id + ':' + window.location.pathname, dedupeWindow: 10000 });
    }

    document.querySelectorAll('[data-pbc-product-list]').forEach(function (list) {
      if (list.dataset.pbcTracked === 'true') return;
      var items = Array.from(list.querySelectorAll('[data-pbc-product-card]')).map(itemFromCard).filter(Boolean);
      if (!items.length) return;
      list.dataset.pbcTracked = 'true';
      var listName = safeText(list.dataset.pbcListName, 160);
      var listId = safeText(list.dataset.pbcListId, 120);
      track('view_item_list', {
        ecommerce: { item_list_name: listName, item_list_id: listId, items: items }
      }, { dedupeKey: 'view_list:' + listId + ':' + window.location.pathname, dedupeWindow: 10000 });
    });

    if (context.page_type === 'cart') {
      track('view_cart', {
        ecommerce: { currency: CURRENCY, value: currentCart.value, items: currentCart.items.map(normalizeItem) }
      }, { dedupeKey: 'view_cart:' + window.location.pathname, dedupeWindow: 10000 });
    }
  }

  function sourceSection(element) {
    if (!element) return '';
    if (element.dataset.pbcSourceSection) return safeText(element.dataset.pbcSourceSection, 80);
    if (element.closest('.site-header,.se-funnel__campaign-header')) return 'header';
    if (element.closest('.site-footer')) return 'footer';
    if (element.closest('.product-page')) return 'product_page';
    if (element.closest('.pbc-custom-order')) return 'floating_banner';
    if (element.closest('.se-funnel__sourcing')) return 'campaign_custom_sourcing';
    if (element.closest('.september-popup')) return 'campaign_popup';
    if (element.closest('[class*="hero"]')) return 'hero';
    return 'page_content';
  }

  function campaignData(element) {
    return {
      campaign_name: safeText(element && element.dataset.pbcCampaignName || context.campaign && context.campaign.campaign_name, 120),
      campaign_id: safeText(element && element.dataset.pbcCampaignId || context.campaign && context.campaign.campaign_id, 100)
    };
  }

  document.addEventListener('click', function (event) {
    try {
      var target = event.target.closest('a,button');
      if (!target) return;
      var card = target.closest('[data-pbc-product-card]');
      if (card && target.closest('a')) {
        var item = itemFromCard(card);
        var ecommerce = { item_list_name: item.item_list_name, item_list_id: item.item_list_id, items: [item] };
        track('select_item', { product_handle: card.dataset.pbcProductHandle || '', ecommerce: ecommerce });
        track('product_card_click', {
          product_handle: card.dataset.pbcProductHandle || '',
          product_position: item.index,
          product_group: item.item_list_id,
          vendor: item.item_brand,
          price: item.price,
          item_list_name: item.item_list_name,
          item_list_id: item.item_list_id
        });
      }

      var customSourcing = target.closest('[data-pbc-custom-sourcing]');
      var href = target.href || '';
      var isWhatsApp = /^(https?:\/\/)?(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)/i.test(href);
      if (customSourcing) {
        track('custom_sourcing_click', Object.assign({
          source_section: sourceSection(customSourcing),
          cta_text: safeText(customSourcing.textContent, 120),
          product_handle: context.product && context.product.product_handle || ''
        }, campaignData(customSourcing)));
      } else if (isWhatsApp) {
        track('whatsapp_click', Object.assign({
          source_section: sourceSection(target),
          cta_text: safeText(target.textContent || target.getAttribute('aria-label'), 120),
          product_handle: context.product && context.product.product_handle || ''
        }, campaignData(target)));
      }

      var campaignCta = target.closest('[data-pbc-campaign-cta]');
      if (campaignCta) {
        track('campaign_cta_click', Object.assign({
          cta_text: safeText(campaignCta.textContent || campaignCta.getAttribute('aria-label'), 120),
          destination: cleanPath(campaignCta.href || ''),
          source_section: sourceSection(campaignCta)
        }, campaignData(campaignCta)));
      }

      var heroCta = target.closest('[data-pbc-hero-cta]');
      if (heroCta) {
        track('hero_cta_click', Object.assign({
          cta_text: safeText(heroCta.textContent || heroCta.getAttribute('aria-label'), 120),
          destination: cleanPath(heroCta.href || ''),
          source_section: sourceSection(heroCta)
        }, campaignData(heroCta)));
      }
    } catch (error) {}
  }, true);

  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      var action = new URL(form.action || '', window.location.origin).pathname;
      if (/\/cart\/add(?:\.js)?$/.test(action)) {
        var itemId = safeText(new FormData(form).get('id'), 100);
        var quantity = Math.max(1, numeric(new FormData(form).get('quantity') || 1));
        var item = normalizeItem(context.product || {}, { item_id: itemId, quantity: quantity });
        storageSet(window.sessionStorage, PENDING_ADD_KEY, JSON.stringify({
          item: item,
          before_quantity: cartQuantity(currentCart, itemId),
          created_at: Date.now()
        }));
      } else if (action === '/cart' && (!event.submitter || event.submitter.name !== 'checkout')) {
        storageSet(window.sessionStorage, PENDING_CART_KEY, JSON.stringify({ cart: currentCart, created_at: Date.now() }));
      }
    } catch (error) {}
  }, true);

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var requestUrl = '';
      try { requestUrl = new URL(typeof args[0] === 'string' ? args[0] : args[0].url, window.location.origin).pathname; } catch (error) {}
      var beforeCart = currentCart;
      return nativeFetch.apply(this, args).then(function (response) {
        if (!response.ok || !/\/cart\/(add|change|update)(?:\.js)?$/.test(requestUrl)) return response;
        response.clone().json().then(function (payload) {
          try {
            if (/\/cart\/add/.test(requestUrl)) {
              var added = payload.items || [payload];
              added.forEach(function (raw, index) {
                var item = normalizeItem(raw, {
                  item_id: raw.variant_id || raw.id,
                  item_name: raw.product_title,
                  item_brand: raw.vendor,
                  item_category: raw.product_type,
                  item_category2: 'Cart',
                  item_variant: raw.variant_title,
                  price: numeric(raw.final_price || raw.price) / 100,
                  quantity: raw.quantity,
                  index: index + 1
                });
                track('add_to_cart', { ecommerce: { currency: CURRENCY, value: item.price * item.quantity, items: [item] } });
              });
              storageRemove(window.sessionStorage, PENDING_ADD_KEY);
            } else {
              trackCartDifferences(beforeCart, normalizeCart(payload));
              storageRemove(window.sessionStorage, PENDING_CART_KEY);
            }
          } catch (error) {}
        }).catch(function () {});
        return response;
      });
    };
  }

  function updateConsent() {
    try {
      if (!window.Shopify || !Shopify.customerPrivacy || !window.pbcGtag) return;
      window.pbcGtag('consent', 'update', {
        analytics_storage: Shopify.customerPrivacy.analyticsProcessingAllowed() ? 'granted' : 'denied',
        ad_storage: Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
        ad_user_data: Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied',
        ad_personalization: Shopify.customerPrivacy.marketingAllowed() ? 'granted' : 'denied'
      });
    } catch (error) {}
  }

  reconcilePendingActions();
  trackPageAndLists();
  updateConsent();
  document.addEventListener('visitorConsentCollected', updateConsent);
})();
